import { __rest } from "tslib";
import * as React from 'react';
const ChevronRightSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M7.70710678,3.99810828 L12.998,9.29610828 L13.0025863,9.29294661 L13.7096931,10.0000534 L13.705,10.0031083 L13.708458,10.006707 L13.0013512,10.7138138 L12.998,10.7101083 L7.70710678,16.0002136 L7,15.2931068 L12.291,10.0021083 L7,4.70521506 L7.70710678,3.99810828 Z" })));
};
ChevronRightSmall.displayName = 'ChevronRightSmall';
export default ChevronRightSmall;
//# sourceMappingURL=ChevronRightSmall.js.map